import {observer, PropTypes as MobXPropTypes} from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import CallNowBtn from 'core/components/v2/CallNowBtn.js';
import CustomBookingBtn from 'core/components/v2/CustomBookingBtn.js';

import autobind from 'common/decorators/autobind.js';
import {DirectoryStoreContextV2} from 'core/stores/RootStore.js';

import {
    PRACTICE_LOC_CONTACT_TYPE,
    DIRECTORY_SEARCH_RESULT_CARD_LINK,
    PRACTICE_LOCATION_CARD,
} from 'core/constants.js';

import {Card, CardV2, Chip, Pill} from '@HealthShareAU/hs-component-library';
export default
@observer
class PracticeLocationV2 extends React.Component {
    static contextType = DirectoryStoreContextV2;
    static propTypes = {
        address: PropTypes.string,
        avatar: PropTypes.string,
        bookingsEnabled: MobXPropTypes.arrayOrObservableArrayOf(
            PropTypes.string,
        ),
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        offersTelehealth: PropTypes.bool,
        phones: MobXPropTypes.arrayOrObservableArrayOf(
            PropTypes.shape({
                number: PropTypes.string.isRequired,
            }),
        ),
        url: PropTypes.string,
    };

    static defaultProps = {
        offersTelehealth: false,
        bookingsEnabled: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            modalDisplayed: false,
        };
        const {id, address, name, phones} = this.props;
        const loc = {
            id,
            address,
            name,
            phones,
            type: PRACTICE_LOC_CONTACT_TYPE,
        };
        this.modalProps = {
            closeModal: this.closeModal,
            contactId: id,
            contactName: name,
            contactType: PRACTICE_LOC_CONTACT_TYPE,
            items: [loc],
            phoneNumber: phones[0]?.number,
        };
    }

    @autobind
    closeModal() {
        this.setState({modalDisplayed: false});
    }

    @autobind
    handlePhoneClick() {
        this.setState({modalDisplayed: true});
    }

    getPhoneNumber() {
        const {phones} = this.props;
        const phone = phones[0];
        if (!phone?.number) {
            return '';
        }
        return {
            phone: phone.number,
            gaSelector: 'call-now-button-secondary',
            gaObjectType: PRACTICE_LOCATION_CARD,
        };
    }

    getAddress() {
        if (this.props.address) {
            const url = this.props.url;
            return {
                addressText: this.props.address,
                gaObjectType: PRACTICE_LOCATION_CARD,
                gaSelector: 'address-link',
                url: url && `${url}#location`,
            };
        }

        return '';
    }

    renderCTA() {
        const {bookingsEnabled, customBookingDataUrl, id, phones} = this.props;

        const {
            rootStore: {
                paramStore: {hasSkin},
                healthFundStore: {
                    healthFundThemeColor,
                    isHealthFundBookingsEnabled,
                },
            },
        } = this.context;

        const colorTheme =
            hasSkin && healthFundThemeColor ? healthFundThemeColor : null;

        const isPLHasPhone = phones?.length;

        if (isHealthFundBookingsEnabled && !hasSkin && customBookingDataUrl) {
            return (
                <CustomBookingBtn
                    colorTheme={colorTheme}
                    gaObjectType={PRACTICE_LOCATION_CARD}
                    customBookingDataUrl={customBookingDataUrl}
                />
            );
        }
        if (isPLHasPhone) {
            return (
                <CallNowBtn
                    colorTheme={colorTheme}
                    gaObjectType={PRACTICE_LOCATION_CARD}
                    modalContent={{...this.modalProps, colorTheme}}
                />
            );
        }
        return null;
    }

    renderSpecialty() {
        const {
            specialty,
            rootStore: {
                paramStore: {isProUser, isReferrals},
            },
        } = this.context;
        if (!specialty) {
            return null;
        }
        return isReferrals || isProUser
            ? specialty.professionalName
            : specialty.name;
    }

    render() {
        const {
            avatar,
            bookingsEnabled,
            customBookingDataUrl,
            hasHicaps,
            name,
            url,
            offersTelehealth,
            phones,
        } = this.props;

        const {
            renderModal,
            telehealthDirectory,
            rootStore: {
                paramStore: {isClient, hasSkin},
                healthFundStore: {healthFundThemeColor},
            },
        } = this.context;
        const {modalDisplayed} = this.state;
        const colorTheme =
            hasSkin && healthFundThemeColor ? healthFundThemeColor : null;
        const directoryCardProps = {
            alt:name,
            avatar: {src: avatar ? avatar : '', icon: 'building'},
            href: url,
            button: this.renderCTA(),
            phoneChip: this.getPhoneNumber(),
            addressChip: this.getAddress(),
            header: name,
            offersTelehealth: offersTelehealth || telehealthDirectory,
            offersHicaps: hasHicaps,
            subheader: this.renderSpecialty(),
            gaObjectType: PRACTICE_LOCATION_CARD,
            gaSelector: DIRECTORY_SEARCH_RESULT_CARD_LINK,
            colorTheme,
            onPhoneClick: () => {
                this.handlePhoneClick();
            },
        };
        return (
            <>
                {modalDisplayed &&
                    renderModal({...this.modalProps, colorTheme})}
                <CardV2 {...directoryCardProps} />
            </>
        );
    }
}
